/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetConsigneeAttachmentsResponse } from '../../models/get-consignee-attachments-response';
import { KeyType } from '../../models/key-type';

export interface GetConsigneeDiscrepancyImagesMetadata$Params {

/**
 * The organization site key
 */
  organizationSiteKey: KeyType;

/**
 * The delivery note key
 */
  deliveryNoteKey: KeyType;
}

export function getConsigneeDiscrepancyImagesMetadata(http: HttpClient, rootUrl: string, params: GetConsigneeDiscrepancyImagesMetadata$Params, context?: HttpContext): Observable<StrictHttpResponse<GetConsigneeAttachmentsResponse>> {
  const rb = new RequestBuilder(rootUrl, getConsigneeDiscrepancyImagesMetadata.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetConsigneeAttachmentsResponse>;
    })
  );
}

getConsigneeDiscrepancyImagesMetadata.PATH = '/organization-sites/{organizationSiteKey}/consignee/delivery-notes/{deliveryNoteKey}/discrepancy-images';
